<template>
	<div class="product-detail-page">

		<div class="container">
			<div style="margin-top: 30px;" v-if="loadingFinish"><el-skeleton :loading="loadingFinish" animated
					:rows="10"> </el-skeleton></div>
			<!-- Product Detail -->
			<div class="detail-info-container" id="detail-info" v-else>
				<div class="left-container" id="left">
					<div id="product-image" class="product-image-container">
						<!-- Main Image Display -->
						<div class="main-image" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave"
							@mousemove="handleMouseMove">
							<img :src="currentMainImage" alt="Product Image" ref="productImage">
							<!-- 放大镜选择框 -->
							<div class="zoom-lens" v-if="showZoom" :style="zoomLensStyle"></div>
						</div>
						<!-- 放大镜显示区域 -->
						<div class="zoom-show" v-if="showZoom" :style="zoomShowStyle">
							<div class="zoom-image" :style="zoomImageStyle"></div>
						</div>

						<!-- Thumbnail Gallery -->
						<div class="thumbnail-container">
							<button class="thumbnail-btn left-btn" @click="scrollThumbnails('left')"
								v-if="goodsInfo.goodsGalleryList.length>6">
								<i class="el-icon-arrow-left"></i>
							</button>
							<div class="thumbnail-scroll-wrapper" ref="thumbnailWrapper"
								:style="{'margin-left':goodsInfo.goodsGalleryList.length>6?'0':'35px'}">
								<div class="thumbnail-list">
									<div v-for="(image, index) in goodsInfo.goodsGalleryList" :key="index"
										class="thumbnail-item" :class="{ 'active': currentImageIndex === index }"
										@mouseenter="currentImageIndex = index">
										<img :src="image" :alt="`Product thumbnail ${index + 1}`">
									</div>
								</div>
							</div>
							<button class="thumbnail-btn right-btn" @click="scrollThumbnails('right')"
								v-if="goodsInfo.goodsGalleryList.length>6">
								<i class="el-icon-arrow-right"></i>
							</button>
						</div>
					</div>
					<div class="section-header" ref="headerFilters">
						<div class="section-divider"></div>
						<h3>{{$t('productIntroduction')}}</h3>
					</div>
					<div style="display: flex;flex-direction: column;" v-if="goodsInfo.intro">
						<div class="intro" v-html="goodsInfo.intro"></div>
					</div>
					<div style="display: flex;flex-direction: column;color: #999;font-size: 15px;align-items: center;" v-else>
						<img src="/icon/common/nodata.png" style="width: 100px;">
						<span>{{$t('notIntro')}}</span>
					</div>
				</div>
				<div class="right-container" id="right" ref="rightContainer">
					<div class="sku-info" :style="{'max-height':maxHeight + 'px'}">
						<div class="product-title">
							<el-tooltip class="item" placement="bottom">
								<div slot="content" style="max-width: 1200px;">
									{{goodsInfo.goodsName}}
								</div>
								<h1>{{goodsInfo.goodsName}}</h1>
							</el-tooltip>
						</div>
						<div class="sales-info">
							<span>{{ $t('sales') }}: {{goodsInfo.buyCount || 0}}</span>
						</div>

						<!-- sku数组 -->
						<div class="color-section" v-for="(sku,index) in skuList" :key="index">
							<div class="section-header">
								<div class="section-divider"></div>
								<h3>{{sku.key}}</h3>
							</div>
							<div class="color-options">
								<div class="color-item" :class="{ 'selected': subSku.active }"
									@click="toggleSkuOption(sku, subSku, subIndex)"
									v-for="(subSku,subIndex) in sku.options" :key="subIndex">
									<!-- <div class="color-image">
										<img src="/img/p8.png" alt="Phantom Black">
									</div> -->
									<span class="color-name">{{subSku.name}}</span>
									<div class="color-stock" v-if="totalBuyNumbers[subSku.name]">
										{{totalBuyNumbers[subSku.name]}}
									</div>
								</div>
							</div>
						</div>
						<!-- 这边显示最后一个sku -->
						<div class="size-section">
							<div class="section-header">
								<div class="section-divider"></div>
								<h3>{{lastSku.key}}</h3>
							</div>
							<div class="size-list">
								<div class="size-item" v-for="(item,index) in lastSku.options" :key="index">
									<span class="size-name">{{item.name}}</span>
									<span class="size-price">
										<span>{{currencySymbol}}</span>
										<span style="margin-left: 3px;">{{ item.price||0 }}</span>
									</span>
									<span class="size-inventory">{{ $t('inventory') }}: {{item.quantity}}</span>
									<div class="quantity-control">
										<el-input-number size="mini" :disabled="item.quantity<=0"
											v-model="item.buyNumber" :min="0" :step="1"
											@change="saveSkuBuyNumber(item, $event)"
											:max="item.quantity"></el-input-number>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 数据汇总 -->
					<div class="total-info">
						<div class="total-price">
							<span>{{currencySymbol}}</span>
							<span style="margin-left: 3px;">{{ totalPrice }}</span>
						</div>
						<div class="total-quantity">{{ $t('selected') }} {{skuCount}}
							{{ $t('unit') }}SKU，{{ $t('total') }} {{totalSum}}
							{{ $t('unitPiece') }}
						</div>
					</div>

					<!-- 操作按钮 -->
					<div class="action-buttons">
						<div style="display: flex;">
							<div class="btn btn-primary btn-lg">
								<i class="el-icon-s-promotion" style="font-size: 24px;"></i> {{ $t('goToBuy') }}
							</div>
							<div class="btn btn-secondary btn-lg" s>
								<i class="el-icon-service" style="font-size: 24px;"></i> {{ $t('customerService') }}
							</div>
						</div>
						<div class="secondary-buttons">
							<div class="btn btn-outline" style="gap: 0;">
								<i class="el-icon-shopping-cart-2" style="font-size: 35px;"></i> {{ $t('addToCart') }}
							</div>
							<div class="btn btn-outline" style="margin-left: 10px;gap: 0;" v-if="!isGoodsCollection"
								@click="addGoodsCollection">
								<i class="el-icon-star-on" style="font-size: 35px;"></i> {{ $t('saveItem') }}
							</div>
							<div class="btn btn-outline btn-outline-collection" style="margin-left: 10px;gap: 0;" v-else
								@click="delGoodsCollection">
								<i class="el-icon-star-on" style="font-size: 35px;"></i> {{ $t('saveItem') }}
							</div>
						</div>
					</div>

					<!-- 商家信息 -->
					<div class="store-info">
						<div class="store-header">
							<img :src="storeInfo.storeLogo" alt="Store Avatar" class="store-avatar">

							<div class="store-name">
								<div style="display: flex;align-items: center;">
									<div class="vip-tag-left">
										<img :src="storeInfo.memberConfigIcon?storeInfo.memberConfigIcon:'/icon/common/vip.svg'"
											style="width: 15px;">
										{{storeInfo.memberConfigName}}
									</div>
									<div class="store-name">
										<span>{{storeInfo.storeName}}</span>
									</div>
								</div>
								<div class="store-stats">
									<span>{{ $t('fans') }}: {{storeInfo.collectionNum || 0}}</span>
									<span>{{ $t('sold') }}: {{storeInfo.storeSales || 0}}</span>
								</div>
								<div class="store-actions">
									<!-- 关注 -->
									<el-button type="warning" plain class="custom-btn" v-if="!isStoreCollection"
										@click="addStoreCollection" :loading="isSubmit" size="small">
										{{ $t('follow') }}</el-button>
									<!-- 取消关注 -->
									<el-button type="warning" plain class="custom-btn" v-else
										@click="delStoreCollection" :loading="isSubmit" size="small">
										{{ $t('unfollow') }}</el-button>
									<!-- 进入店铺 -->
									<el-button type="primary" size="small" plain
										@click="handleDetail">{{ $t('enter') }}</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 相关商品 -->
			<div class="section-header" ref="headerFilters">
				<div class="section-divider"></div>
				<h3>{{ $t('relateProduct') }}</h3>
			</div>

			<ProductListForRecommend ref="recommendProductList" />

			<RightFixedPanel @openEnquiry="enquiryDialogVisible = true"
				@openComplaint="complaintDialogVisible = true" />

			<EnquiryDialog :visible.sync="enquiryDialogVisible" />

			<ComplaintDialog :visible.sync="complaintDialogVisible" />
		</div>
	</div>
</template>

<script>
	import storage from "@/utils/storage.js";
	import RightFixedPanel from '@/components/RightFixedPanel.vue';
	import EnquiryDialog from '@/components/EnquiryDialog.vue';
	import ComplaintDialog from '@/components/ComplaintDialog.vue'
	import ProductListForRecommend from '@/components/ProductListForRecommend.vue';
	import goodsApi from '@/api/product';
	import merchantApi from '@/api/merchant';
	import collectionApi from '@/api/collection';
	export default {
		name: 'Product',
		components: {
			RightFixedPanel,
			EnquiryDialog,
			ComplaintDialog,
			ProductListForRecommend
		},
		data() {
			return {
				isSubmit: false,
				isStoreCollection: false, //是否已关注商家
				isGoodsCollection: false, //是否已收藏商品
				maxHeight: 550, //sku可滑动的最大高度
				loadingFinish: true,
				enquiryDialogVisible: false,
				complaintDialogVisible: false,
				searchKeyword: '',
				isSearchFixed: false,
				isSearchFilterFixed: false,
				// 查询条件
				sortBy: 'default',
				platform: 'all',
				priceRange: 'all',
				brand: 'all',
				shipping: 'all',
				// 选中的颜色索引
				selectedColorIndex: 0,
				productImages: [],
				currentImageIndex: 0,
				goodsId: '',
				goodsInfo: {},
				storeInfo: {},
				// 放大镜相关
				showZoom: false,
				zoomLensStyle: {},
				zoomShowStyle: {},
				zoomImageStyle: {},
				imageWidth: 0,
				imageHeight: 0,
				imageLeft: 0, // 图片距离容器左边的距离
				imageTop: 0, // 图片距离容器顶部的距离
				lensSize: 100,
				zoomSize: 600,
				// 图片实际尺寸
				originalImageWidth: 0,
				originalImageHeight: 0,
				skuList: [],
				lastSku: {}, // 存储最后一个 sku 对象
				skuBuyNumbers: {}, // 存储每个 SKU 的购买数量
				totalBuyNumbers: {}, // 存储每个 key 汇总的购买数量
				skuCount: 0, // SKU 数量
				totalSum: 0, // 总购买数量
				totalPrice: 0, // 总价格
				currencySymbol: '',
				accessToken: storage.getToken()
			}
		},
		computed: {
			currentMainImage() {
				return this.productImages[this.currentImageIndex] || this.goodsInfo.thumbnail;
			}
		},
		mounted() {
			if (this.$route.query.goodsId) {
				this.goodsId = this.$route.query.goodsId
			}
			this.currencySymbol = storage.getCurrencySymbol();
			// 添加滚动事件监听器
			window.addEventListener('scroll', this.handleScroll)
			// 添加 resize 事件监听器以处理窗口大小变化
			window.addEventListener('resize', this.handleScroll)
			// 添加 resize 事件监听器以处理窗口大小变化，重新计算高度
			window.addEventListener('resize', this.calculateHeights)
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll)
				window.removeEventListener('resize', this.handleScroll)
				window.removeEventListener('resize', this.calculateHeights)
			})
			this.getGoodsDetail();
		},
		methods: {
			//获取商品详情
			async getGoodsDetail() {
				const res = await goodsApi.getGoodsDetail(this.goodsId, {
					rateCode: storage.getCurrency()
				});
				this.goodsInfo = res.result;
				this.getIsGoodsCollection();
				this.getSkuInfo();
				this.productImages = this.goodsInfo.goodsGalleryList;
				await this.getStoreDetail();
				this.loadingFinish = false;
				this.$nextTick(() => {
					this.loadGoods();
				});
				setTimeout(() => {
					// 初始计算高度
					this.calculateHeights();
				}, 0)
			},
			//获取商家详情
			async getStoreDetail() {
				const res = await merchantApi.getStoreDetail(this.goodsInfo.storeId);
				this.storeInfo = res.result;
				this.getIsStoreCollection();
			},
			//将sku拼装成页面需要显示的数据
			getSkuInfo() {
				// 初始化规格映射，用于存储规格名称和对应的不重复规格值
				const specMap = new Map();
				// 提取规格信息
				if (this.goodsInfo?.skuList && Array.isArray(this.goodsInfo.skuList)) {
					this.goodsInfo.skuList.forEach(sku => {
						if (sku?.specList && Array.isArray(sku.specList)) {
							sku.specList.forEach(spec => {
								// 跳过 images 规格，只处理有效的规格
								if (spec?.specName && spec.specName !== 'images' && spec?.specValue) {
									if (!specMap.has(spec.specName)) {
										specMap.set(spec.specName, new Set());
									}
									specMap.get(spec.specName).add(spec.specValue);
								}
							});
						}
					});
				}
				// 转换为页面需要显示的数据格式
				const result = [];
				const firstSkuLabel = [];
				specMap.forEach((valueSet, specName) => {
					const optionsArray = Array.from(valueSet);
					const options = optionsArray.map((name, index) => ({
						name, // 规格值
						active: index === 0 // 第一个对象默认选中
					}));
					result.push({
						key: specName,
						options,
						label: optionsArray[0] // 默认选中第一个规格值
					});
					firstSkuLabel.push(optionsArray[0]);
				});
				// 移除最后一个元素，用于后续规格匹配
				if (firstSkuLabel.length > 0) {
					firstSkuLabel.splice(firstSkuLabel.length - 1, 1);
				}
				// 存储最后一个 sku 对象并从 result 中移除
				this.lastSku = null;
				if (result.length > 0) {
					this.lastSku = result[result.length - 1];
					result.pop();
				}
				console.log(this.lastSku)
				// 为最后一个 SKU 的选项添加库存、价格和购买数量
				if (this.lastSku && this.lastSku.options) {
					this.lastSku.options.forEach(item => {
						const spec = firstSkuLabel.length > 0 ? (firstSkuLabel.join(' ') + ' ' + item.name) : item
							.name;
						// 查找对应的 SKU 信息
						const skuInfo = this.goodsInfo.skuList.find(sku => sku.simpleSpec === spec);
						console.log("skuInfo", skuInfo)
						if (skuInfo) {
							item.skuId = skuInfo.skuId || skuInfo.id;
							item.quantity = skuInfo.quantity || 0;
							item.price = skuInfo.price;
							item.buyNumber = 0;
						}
					});
				}
				this.skuList = result;
				console.log("最后一个sku====", this.skuList)
			},
			// 保存 SKU 购买数量的方法
			saveSkuBuyNumber(item, buyNumber) {
				// 计算总价格和构建 selectSkuList
				let totalPrice = 0;
				this.selectSkuList = [];
				if (this.skuList.length == 0) {
					// skuList 为空时，直接使用 item.name 作为键
					const uniqueKey = item.name;
					// 如果购买数量为0，则从 skuBuyNumbers 中删除对应的属性
					if (buyNumber === 0) {
						delete this.skuBuyNumbers[uniqueKey];
					} else {
						this.skuBuyNumbers[uniqueKey] = buyNumber;
					}
					// 直接使用 skuBuyNumbers 作为 totalBuyNumbers
					this.totalBuyNumbers = {
						...this.skuBuyNumbers
					};
					// 计算 SKU 数量和总购买数量
					this.skuCount = Object.keys(this.skuBuyNumbers).length;
					this.totalSum = Object.values(this.totalBuyNumbers).reduce((sum, value) => sum + (value || 0), 0);
					// 遍历所有已保存的 SKU 购买数量
					Object.keys(this.skuBuyNumbers).forEach(uniqueKey => {
						const buyNumber = this.skuBuyNumbers[uniqueKey];
						// 查找对应的 SKU 信息
						const skuInfo = this.goodsInfo.skuList.find(sku => sku.simpleSpec === uniqueKey);
						if (skuInfo) {
							totalPrice += skuInfo.price * buyNumber;
							this.selectSkuList.push({
								...skuInfo,
								buyNumber: buyNumber
							});
						} else if (this.lastSku && this.lastSku.options) {
							// 如果在 goodsInfo.skuList 中找不到，尝试从 lastSku.options 中查找
							const skuItem = this.lastSku.options.find(opt => opt.name === uniqueKey);
							if (skuItem && skuItem.price) {
								totalPrice += skuItem.price * buyNumber;
								this.selectSkuList.push({
									skuId: skuItem.skuId,
									buyNumber: buyNumber,
									quantity: skuItem.quantity,
									price: skuItem.price,
									name: skuItem.name
								});
							}
						}
					});
					this.totalPrice = totalPrice.toFixed(2);
					console.log('购买数量已保存 (空 skuList):', this.skuBuyNumbers);
					console.log('汇总购买数量 (空 skuList):', this.totalBuyNumbers);
					console.log('SKU 数量 (空 skuList):', this.skuCount, '、总购买数量:', this.totalSum, '、总价格:', this.totalPrice);
					console.log('最终选择的sku信息 (空 skuList)：', this.selectSkuList);
				} else {
					// 使用 skuList的label 作为唯一键值
					const keys = this.skuList.map(item => item.label);
					if (keys.length > 0) {
						// 唯一键值
						const uniqueKey = `${keys.join('_')}_${item.name}`;
						// 如果购买数量为0，则从 skuBuyNumbers 中删除对应的属性
						if (buyNumber === 0) {
							delete this.skuBuyNumbers[uniqueKey];
						} else {
							this.skuBuyNumbers[uniqueKey] = buyNumber;
						}
						// 汇总同一 key 下的所有购买数量
						let total = 0;
						Object.keys(this.skuBuyNumbers).forEach(skuKey => {
							if (skuKey.startsWith(keys[0] + '_')) {
								total += this.skuBuyNumbers[skuKey] || 0;
							}
						});
						// 如果汇总数量为0，则从 totalBuyNumbers 中删除对应的属性
						if (total === 0) {
							delete this.totalBuyNumbers[keys[0]];
						} else {
							this.totalBuyNumbers[keys[0]] = total;
						}
						// 计算 this.skuBuyNumbers 里面有几个属性
						this.skuCount = Object.keys(this.skuBuyNumbers).length;
						// 计算 this.totalBuyNumbers 对象里所有的数据汇总
						this.totalSum = Object.values(this.totalBuyNumbers).reduce((sum, value) => sum + (value || 0), 0);
						// 遍历所有已保存的 SKU 购买数量
						Object.keys(this.skuBuyNumbers).forEach(uniqueKey => {
							const buyNumber = this.skuBuyNumbers[uniqueKey];
							// 查找对应的 SKU 信息
							var spec = uniqueKey.split('_').join(' ');
							const skuInfo = this.goodsInfo.skuList.find(sku => sku.simpleSpec === spec);
							if (skuInfo) {
								totalPrice += skuInfo.price * buyNumber;
								this.selectSkuList.push({
									...skuInfo,
									buyNumber: buyNumber
								});
							}
						});
						this.totalPrice = totalPrice.toFixed(2);
						console.log('购买数量已保存:', this.skuBuyNumbers);
						console.log('汇总购买数量:', this.totalBuyNumbers);
						console.log('SKU 数量:', this.skuCount, '、总购买数量:', this.totalSum, '、总价格:', this.totalPrice);
						console.log('最终选择的sku信息，可直接加入购物车：', this.selectSkuList);
					}
				}
				this.$forceUpdate();
			},
			// 切换 SKU 选项的选中状态
			toggleSkuOption(sku, clickedOption, index) {
				// 更新当前规格的选中状态
				sku.options.forEach((option, i) => {
					option.active = i === index;
				});
				// 更新 sku 的 label 为当前选中的选项值
				sku.label = clickedOption.name;
				// 收集所有选中的规格值
				const selectedSpecs = this.skuList.map(spec => spec.label);
				// 为最后一个 SKU 的选项添加库存、价格和购买数量
				if (this.lastSku && this.lastSku.options) {
					this.lastSku.options.forEach(item => {
						const spec = selectedSpecs.join(' ') + ' ' + item.name;
						// 查找对应的 SKU 信息
						const skuInfo = this.goodsInfo.skuList.find(sku => sku.simpleSpec === spec);
						if (skuInfo) {
							item.skuId = skuInfo.skuId || skuInfo.id;
							item.quantity = skuInfo.quantity || 0;
							item.price = skuInfo.price;
							const uniqueKey = selectedSpecs.join('_') + '_' + item.name;
							item.buyNumber = this.skuBuyNumbers[uniqueKey] || 0;
						}
					});
				}
			},
			//加载商品列表
			async loadGoods() {
				if (this.$refs.recommendProductList && typeof this.$refs.recommendProductList.init === 'function') {
					this.$refs.recommendProductList.init();
				}
			},
			setRightContainerWidth() {
				const leftElement = document.getElementById('left');
				const rightElement = document.getElementById('right');
				if (leftElement && rightElement) {
					// 获取left容器的实际宽度
					const leftWidth = leftElement.offsetWidth;
					// 设置right容器的宽度，确保与left容器一致
					rightElement.style.width = leftWidth + 'px';
					// 存储宽度供fixed定位时使用
					this.rightContainerWidth = leftWidth;
				}
			},
			scrollThumbnails(direction) {
				const thumbnailWrapper = this.$refs.thumbnailWrapper;
				if (!thumbnailWrapper) return;

				const scrollAmount = 300; // Adjust this value based on your needs
				if (direction === 'left') {
					thumbnailWrapper.scrollLeft -= scrollAmount;
				} else {
					thumbnailWrapper.scrollLeft += scrollAmount;
				}
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// 简单实现搜索框固定效果
				this.isSearchFixed = scrollTop > 100;
				this.isSearchFilterFixed = scrollTop > 160;
			},
			// 跳转到商家内页
			handleDetail() {
				window.open(`/merchant-detail?id=${this.goodsInfo.storeId}`)
			},
			// 鼠标进入图片区域
			handleMouseEnter(e) {
				const productImage = this.$refs.productImage;
				if (productImage) {
					this.showZoom = true;
					this.$nextTick(() => {
						this.calculateZoom();
					});
				}
			},
			// 鼠标离开图片区域
			handleMouseLeave() {
				this.showZoom = false;
			},
			// 鼠标在图片上移动
			handleMouseMove(e) {
				if (!this.showZoom) return;

				const productImage = this.$refs.productImage;
				if (!productImage) return;

				// 获取鼠标在main-image容器中的坐标
				const mainImageContainer = productImage.parentElement;
				const containerRect = mainImageContainer.getBoundingClientRect();
				const mouseXInContainer = e.clientX - containerRect.left;
				const mouseYInContainer = e.clientY - containerRect.top;

				// 计算鼠标在图片区域内的相对坐标
				const mouseXInImage = mouseXInContainer - this.imageLeft;
				const mouseYInImage = mouseYInContainer - this.imageTop;

				// 检查鼠标是否在图片区域内
				if (mouseXInImage >= 0 && mouseXInImage <= this.imageWidth &&
					mouseYInImage >= 0 && mouseYInImage <= this.imageHeight) {
					// 计算放大镜位置
					this.updateZoomPosition(mouseXInImage, mouseYInImage);
				}
			},
			// 计算放大镜相关参数
			calculateZoom() {
				const productImage = this.$refs.productImage;
				if (!productImage) return;

				// 获取main-image容器尺寸
				const mainImageContainer = productImage.parentElement;
				const containerWidth = mainImageContainer.offsetWidth;
				const containerHeight = mainImageContainer.offsetHeight;

				// 存储图片尺寸信息（使用getBoundingClientRect获取实际渲染尺寸）
				const rect = productImage.getBoundingClientRect();
				this.imageWidth = rect.width;
				this.imageHeight = rect.height;

				// 计算图片在容器中的位置（居中显示）
				this.imageLeft = (containerWidth - this.imageWidth) / 2;
				this.imageTop = (containerHeight - this.imageHeight) / 2;

				// 获取图片实际尺寸
				this.getOriginalImageSize(productImage.src);

				this.lensSize = 100; // 放大镜选择框尺寸
				this.zoomSize = 600; // 放大显示区域尺寸

				// 设置放大显示区域位置
				this.zoomShowStyle = {
					top: this.imageTop + 'px',
					left: (this.imageLeft + this.imageWidth + 20) + 'px',
					width: this.zoomSize + 'px',
					height: this.zoomSize + 'px'
				};
			},
			// 获取图片实际尺寸
			getOriginalImageSize(imageUrl) {
				const img = new Image();
				img.onload = () => {
					this.originalImageWidth = img.width;
					this.originalImageHeight = img.height;
				};
				img.src = imageUrl;
			},
			// 更新放大镜位置
			updateZoomPosition(mouseX, mouseY) {
				// 计算放大镜选择框位置，确保不超出图片范围
				let lensX = mouseX - this.lensSize / 2;
				let lensY = mouseY - this.lensSize / 2;

				// 边界限制（基于图片实际尺寸）
				lensX = Math.max(0, Math.min(lensX, this.imageWidth - this.lensSize));
				lensY = Math.max(0, Math.min(lensY, this.imageHeight - this.lensSize));

				// 设置选择框样式，加上图片在容器中的偏移量
				this.zoomLensStyle = {
					left: (this.imageLeft + lensX) + 'px',
					top: (this.imageTop + lensY) + 'px',
					width: this.lensSize + 'px',
					height: this.lensSize + 'px'
				};

				// 计算放大图片位置
				// 计算选择框在图片中的相对位置（0-1范围）
				const relativeX = lensX / this.imageWidth;
				const relativeY = lensY / this.imageHeight;

				// 计算放大图片的偏移量
				const zoomScale = 1.5;
				const zoomX = -relativeX * (this.originalImageWidth * zoomScale - this.zoomSize);
				const zoomY = -relativeY * (this.originalImageHeight * zoomScale - this.zoomSize);

				// 设置放大图片样式
				this.zoomImageStyle = {
					backgroundImage: `url(${this.currentMainImage})`,
					backgroundPosition: `${zoomX}px ${zoomY}px`,
					backgroundSize: `${this.originalImageWidth * zoomScale}px ${this.originalImageHeight * zoomScale}px`,
					width: this.zoomSize + 'px',
					height: this.zoomSize + 'px'
				};
			},
			// 计算高度并输出到控制台
			calculateHeights() {
				// 获取total-info元素的高度
				const totalInfoElement = document.querySelector('.total-info');
				const totalInfoHeight = totalInfoElement ? totalInfoElement.offsetHeight : 0;

				// 获取action-buttons元素的高度
				const actionButtonsElement = document.querySelector('.action-buttons');
				const actionButtonsHeight = actionButtonsElement ? actionButtonsElement.offsetHeight : 0;

				// 获取App.vue页面中app-header的高度
				const appHeaderElement = document.querySelector('.app-header');
				const appHeaderHeight = appHeaderElement ? appHeaderElement.offsetHeight : 0;

				// 获取当前页面的可显示区域高度
				const viewportHeight = window.innerHeight;

				// 计算其他固定高度的元素（如store-info等）
				const storeInfoElement = document.querySelector('.store-info');
				const storeInfoHeight = storeInfoElement ? storeInfoElement.offsetHeight : 0;

				// 计算间距和其他元素的高度
				const paddingAndMargin = 40; // 假设的间距值

				// 计算剩余可显示高度
				const remainingHeight = viewportHeight - appHeaderHeight;

				// 计算sku-info的最大高度
				const skuInfoMaxHeight = remainingHeight - (totalInfoHeight + actionButtonsHeight + storeInfoHeight +
					paddingAndMargin);

				// 设置maxHeight数据属性
				if (skuInfoMaxHeight > 0) {
					this.maxHeight = skuInfoMaxHeight + 80;
				}
			},
			//用户是否关注
			async getIsStoreCollection() {
				//获取当前登录用户是否有关注
				if (this.accessToken) {
					const res = await collectionApi.isStoreCollection(this.goodsInfo.storeId);
					this.isStoreCollection = res.result;
				}
			},
			//关注商家
			async addStoreCollection() {
				if (!this.accessToken) {
					this.handleLogin();
				} else {
					this.isSubmit = true;
					const res = await collectionApi.addStoreCollection(this.goodsInfo.storeId);
					this.isSubmit = false;
					if (res.code == 200) {
						this.isStoreCollection = true;
						this.$message.success(this.$t('followSuccess'))
					} else {
						this.$message.warning(this.$t('followFail'))
					}
				}
			},
			//取消关注
			async delStoreCollection() {
				if (!this.accessToken) {
					this.handleLogin();
				} else {
					this.isSubmit = true;
					const res = await collectionApi.delStoreCollection(this.goodsInfo.storeId);
					this.isSubmit = false;
					if (res.code == 200) {
						this.isStoreCollection = false;
						this.$message.success(this.$t('followCancel'))
					} else {
						this.$message.warning(this.$t('followFail'))
					}
				}
			},

			//用户是否收藏商品
			async getIsGoodsCollection() {
				//获取当前登录用户是否有收藏商品
				if (this.accessToken) {
					const res = await collectionApi.isGoodsCollection(this.goodsInfo.id);
					this.isGoodsCollection = res.result;
				}
			},
			//收藏商品
			async addGoodsCollection() {
				if (!this.accessToken) {
					this.handleLogin();
				} else {
					const res = await collectionApi.addGoodsCollection(this.goodsInfo.id);
					if (res.code == 200) {
						this.isGoodsCollection = true;
						this.$message.success(this.$t('saveItemSuccess'))
					} else {
						this.$message.warning(this.$t('saveItemFail'))
					}
				}
			},
			//取消收藏商品
			async delGoodsCollection() {
				if (!this.accessToken) {
					this.handleLogin();
				} else {
					const res = await collectionApi.delGoodsCollection(this.goodsInfo.id);
					if (res.code == 200) {
						this.isGoodsCollection = false;
						this.$message.success(this.$t('saveItemCancel'))
					} else {
						this.$message.warning(this.$t('saveItemFail'))
					}
				}
			},
			handleLogin() {
				this.$confirm(this.$t('loginMessage'), this.$t('tip'), {
					confirmButtonText: this.$t('gotoLogin'),
					cancelButtonText: this.$t('closeLogin'),
					type: 'warning'
				}).then(() => {
					this.$router.push('/login')
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
		}
	}
</script>

<style scoped>
	.intro {
		width: 100%;
		line-height: 1.6;
	}

	/* 富文本中的图片样式 */
	.intro :deep(img) {
		width: 100% !important;
		height: auto !important;
		display: block !important;
		margin: 0 !important;
		padding: 0 !important;
		border: none !important;
		max-width: 100% !important;
	}

	/* 确保图片之间无间隔 */
	.intro :deep(p) {
		margin: 0 !important;
		padding: 0 !important;
	}

	.intro :deep(div) {
		margin: 0 !important;
		padding: 0 !important;
	}

	.product-detail-page {
		padding: 0;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.detail-info-container {
		display: flex;
		position: relative;
	}

	.left-container {
		width: 50%;
		height: 100%;
		padding: 20px 0;
	}

	.right-container {
		width: 50%;
		height: auto;
		background-color: white;
		padding: 20px;
		box-sizing: border-box;
		position: -webkit-sticky;
		position: sticky;
		top: 0;
		z-index: 1;
		align-self: flex-start;
		max-height: 100vh;
	}

	/* Product Title */
	.product-title h1 {
		font-size: 18px;
		font-weight: normal;
		margin: 0 0 10px 0;
		color: #333;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	/* Sales Info */
	.sales-info {
		color: #D9001B;
		font-size: 14px;
		margin-bottom: 20px;
	}

	/* Color Section */
	.color-section,
	.size-section {
		margin-bottom: 25px;
	}

	/* Product Image Gallery Styles */
	.product-image-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.main-image {
		position: relative;
		width: 100%;
		height: 500px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 20px 0;
		margin-bottom: 15px;
		cursor: pointer;
	}

	.main-image img {
		max-width: 100%;
		max-height: 500px;
		object-fit: contain;
	}

	/* 放大镜选择框 */
	.zoom-lens {
		position: absolute;
		border: 1px solid #ccc;
		background-color: rgba(255, 255, 255, 0.3);
		cursor: pointer;
		z-index: 10;
	}

	/* 放大镜显示区域 */
	.zoom-show {
		position: absolute;
		border: 1px solid #e0e0e0;
		overflow: hidden;
		background-color: #fff;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
		z-index: 9999;
	}

	/* 放大图片 */
	.zoom-image {
		position: relative;
		z-index: 1;
	}

	.thumbnail-container {
		width: 100%;
		display: flex;
		align-items: center;
		position: relative;
	}

	.thumbnail-btn {
		width: 30px;
		height: 30px;
		background-color: #fff;
		border: 1px solid #ddd;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		z-index: 10;
		font-size: 16px;
	}

	.thumbnail-btn:hover {
		background-color: #f5f5f5;
	}

	.left-btn {
		margin-right: 10px;
	}

	.right-btn {
		margin-left: 10px;
	}

	.thumbnail-scroll-wrapper {
		flex: 1;
		overflow-x: hidden;
		overflow-y: hidden;
		scrollbar-width: thin;
		scrollbar-color: #fff #fff;
	}

	.thumbnail-scroll-wrapper::-webkit-scrollbar {
		height: 6px;
	}

	.thumbnail-scroll-wrapper::-webkit-scrollbar-track {
		background: #fff;
	}

	.thumbnail-scroll-wrapper::-webkit-scrollbar-thumb {
		background-color: #ddd;
		border-radius: 3px;
	}

	.thumbnail-list {
		display: flex;
		gap: 10px;
		padding: 5px 0;
		min-width: max-content;
	}

	.thumbnail-item {
		width: 80px;
		height: 80px;
		border: 2px solid transparent;
		cursor: pointer;
		transition: border-color 0.2s ease;
		background-color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 3px;
		border-radius: 5px;
	}

	.thumbnail-item:hover {
		border-color: #ff9900;
		border-radius: 5px;
	}

	.thumbnail-item.active {
		border-color: #ff9900;
		background-color: #FEF5E9;
	}

	.thumbnail-item img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	/* Color Options */
	.color-options {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}

	.color-item {
		display: flex;
		align-items: center;
		padding: 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		cursor: pointer;
		transition: border-color 0.3s;
		position: relative;
		padding: 10px 20px;
	}

	.color-item:hover {
		border-color: #ff9900;
	}

	.color-item.selected {
		border-color: #ff9900;
		background: #FEF5E9;
	}

	.color-item.selected .color-name {
		color: #ff9900;
	}

	.color-image {
		width: 40px;
		height: 40px;
		margin-right: 10px;
	}

	.color-image img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.color-name {
		font-size: 14px;
		color: #333;
		flex-grow: 1;
	}

	.color-stock {
		background-color: #D9001B;
		color: white;
		font-size: 12px;
		padding: 2px 6px;
		border-radius: 10px;
		position: absolute;
		top: -8px;
		right: -8px;
	}

	.recommended-size {
		color: #016AF8;
		font-weight: bold;
	}

	.recommendation-note {
		font-size: 12px !important;
		color: #999;
		margin-bottom: 0 !important;
	}

	/* Size List */
	.size-list {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.size-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 4px 10px;
		border-radius: 4px;
	}

	.size-name {
		font-size: 14px;
		font-weight: bold;
		color: #333;
		min-width: 50px;
		width: 150px;
	}

	.size-price {
		font-size: 14px;
		color: #D9001B;
		font-weight: bold;
		margin-right: 15px;
	}

	.size-inventory {
		font-size: 13px;
		color: #999;
		margin-right: 15px;
		width: 100px;
	}

	/* Quantity Control */
	.quantity-control {
		display: flex;
		align-items: center;
	}

	/* Total Info */
	.total-info {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 15px;
		background-color: #f9f9f9;
		margin-bottom: 20px;
		border-radius: 4px;
	}

	.total-price {
		font-size: 24px;
		color: #D9001B;
		font-weight: bold;
	}

	.total-quantity {
		font-size: 14px;
		color: #666;
	}

	/* Action Buttons */
	.action-buttons {
		margin-bottom: 25px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.btn {
		border: none;
		cursor: pointer;
		font-size: 14px;
		transition: all 0.3s;
		text-decoration: none;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
	}

	.btn-primary {
		background-color: #D9001B;
		color: white;
		border-radius: 10px 0 0 10px;
		padding: 12px 20px;
	}

	.btn-primary:hover {
		background-color: #ff4400;
	}

	.btn-secondary {
		background-color: #016AF8;
		color: white;
		border-radius: 0 10px 10px 0;
		padding: 12px 20px;
	}

	.btn-secondary:hover {
		background-color: #0066cc;
	}

	.btn-outline {
		display: flex;
		flex-direction: column;
		background-color: white;
		color: #333;
	}

	.btn-outline-collection {
		border-color: #016AF8;
		color: #016AF8;
	}

	.btn-lg {
		width: 180px;
		font-size: 16px;
		padding: 15px;
		font-weight: bold;
	}

	.secondary-buttons {
		display: flex;
		gap: 10px;
	}

	/* Store Info */
	.store-info {
		border-top: 1px solid #eee;
		padding-top: 20px;
	}

	.store-header {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.store-avatar {
		width: 90px;
		height: 90px;
		border-radius: 10px;
		margin-right: 10px;
	}

	.store-badge {
		background-color: #D9001B;
		color: white;
		font-size: 10px;
		padding: 2px 5px;
		border-radius: 3px;
		margin-right: 10px;
	}

	.store-name {
		font-size: 14px;
		color: #333;
		font-weight: bold;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
	}

	.store-stats {
		display: flex;
		gap: 15px;
		margin: 10px 0;
	}

	.store-stats span {
		font-size: 13px;
		color: #999;
		font-weight: normal;
	}

	.store-actions {
		display: flex;
		gap: 10px;
	}

	.section-header {
		display: flex;
		align-items: center;
		gap: 10px;
		margin: 20px 0;
	}

	.section-divider {
		width: 5px;
		height: 20px;
		background-color: #016AF8;
		border-radius: 2px;
	}

	:deep .el-button {
		width: 200px;
	}

	:deep .el-input-number--mini {
		width: 100px;
	}

	.sku-info {
		overflow: auto;
	}

	::-webkit-scrollbar {
		width: 2px;
		height: 5px;
	}

	::-webkit-scrollbar-thumb {
		border-radius: 1em;
		background-color: rgba(50, 50, 50, .3);
	}

	::-webkit-scrollbar-track {
		border-radius: 1em;
		background-color: rgba(50, 50, 50, .1);
	}
</style>